import { LogOut } from "lucide-react";
import styles from "./Sidebar.module.css";

const SidebarUserCard = ({
  user,
  isCollapsed,
  onOpenProfile,
  onLogoutClick,
}) => {
  const displayName = user?.full_name || user?.name || "User";
  const displayRole =
    user?.system_role ||
    user?.primary_role ||
    user?.user_type ||
    user?.role ||
    "Member";

  return (
    <div
      className={`${styles.userCard} ${
        isCollapsed ? styles.userCardCollapsed : ""
      }`}
    >
      <button
        type="button"
        onClick={onOpenProfile}
        className={styles.userInfo}
        title={isCollapsed ? `${displayName} (${displayRole})` : "View Profile"}
      >
        <img
          src={
            user?.profile_picture ||
            user?.photo_url ||
            "https://images.unsplash.com/photo-1544723795-3fb6469f5b39"
          }
          alt={displayName}
          className={styles.userAvatar}
        />
        {!isCollapsed && (
          <div className={styles.userDetails}>
            <span className={styles.userName}>{displayName}</span>
            <span className={styles.userRole}>{displayRole}</span>
          </div>
        )}
      </button>

      <button
        type="button"
        onClick={onLogoutClick}
        className={styles.logoutBtn}
        aria-label="Logout"
        title="Logout"
      >
        <LogOut size={17} />
      </button>
    </div>
  );
};

export default SidebarUserCard;
